<div class="card bg-card">
    <!--title and icon-->
    <div class="row">
        <div class="col-sm-9 col-xs-12">
            <h5 class="text-primary fw-bolder" [title]="cardModel() | translateToken: 'title'">{{ cardModel() | translateToken: "title" }}</h5>
        </div>

        @if (cardModel().iconId) {
            <div class="col-sm-3 col-xs-12">
                <adaa-picture [pictureId]="cardModel().iconId" width="23px" height="23px" [style]="'object-fit: cover; border-radius: 50%'" />
            </div>
        }
    </div>

    <!--value-->
    <h6 class="fw-bold mt-1 mb-1 d-flex align-items-end value" [title]="lastValue()">{{ lastValue() }}</h6>

    <!--data source -->
    <h6
        class="data-source mt-1 mb-0 d-flex align-items-center text-secondary"
        [title]="useBigCard() ? extraDetails() : (cardModel() | translateToken: 'dataSource')"
    >
        {{ useBigCard() ? extraDetails() : (cardModel() | translateToken: "dataSource") }}
    </h6>

    @if (useBigCard()) {
        <div class="divider"></div>
        <h6 class="prev-details mt-1 mb-0 d-flex align-items-center text-secondary" [title]="prevDetails()">
            {{ "common.form.button.previous" | translate }}: {{ prevDetails() }}
        </h6>
    }
</div>
